module.exports = __webpack_public_path__ + "static/media/tlyfeLogo.4f966fa1.png";